export const infoPageData = {
    navLinks: [
        { 
            to: 'the-company',
            label: 'The company',
            subMenus: 
                [
                { to: 'core-purpose', label: 'Core  Purpose'} ,
                {to: 'core-values', label: 'Core Values'} ,
                { to: 'principles', label: 'Principles'} ,
                { to: 'mission', label: 'Mission'} ,
                { to: 'the-vision', label: 'The Vision'} ,
                { to: 'the-story', label: 'The Story'} ,
                { to: 'our-business-model', label: 'Our Business Model'} ,
            ],
        },

        { 
            to: 'the-team',
            label: 'The Team',
            subMenus: 
                [
                    { to: 'core-purpose', label: 'Core  Purpose'} ,
                    { to: 'principles', label: 'Principles'} ,
            ],
        },

        

        { to: 'the-approach', label: 'The Approach'} ,
        { to: 'the-culture', label: 'The Culture'} ,
        { to: 'the-stories', label: 'The Stories'} ,
    ],

    
    overview: {
        title: 'Overview',
        paragraphOne: 'In an era defined by rapid technological advancements and shifting market dynamics, the ability to architect your next move is crucial for sustained success. This section provides an overview of the key strategies and insights that can help businesses navigate the complexities of the digital landscape and position themselves for future growth.',
        paragraphTwo: "From embracing emerging technologies to fostering a culture of innovation, we explore the essential elements that contribute to successful transformation. Discover how to identify new opportunities, mitigate risks, and create a roadmap for your organization's future in this ever-evolving business environment.",
        paragraphThree: "Whether you're a seasoned executive or an aspiring leader, this section offers valuable perspectives and actionable insights to help you architect your next move with confidence and agility.",
    },
    videoSection: {
        title: 'Video Content',
    },
    contentSection: {
        title: 'KDA Design Technologies Research',
        cards: [
            { title: 'Digital Core Capabilities', to: '/info/the-team/', className: 'gc1s4 vh-30 ba pa1-00 h-100 w-100' },
            { title: 'Digital Operating Model', to: '/architect-your-next/digital-operating-model/', className: 'gc1s4 gr2s1 vh-30 ba pa1-00 h-100 w-100' },
            { title: 'Tales of Transformation', to: '/architect-your-next/tales-of-transformation/', className: 'gc5s4 gr1s2 ba pa1-00 h-100 w-100' },
            { title: 'Empowering Talent Transformation', to: '/architect-your-next/empowering-talent-transformation/', className: 'gc9s4 gr1s1 vh-30 ba pa1-00 h-100 w-100' },
            { title: 'Architecting New Possibilities', to: '/architect-your-next/architecting-new-possibilities/', className: 'gc9s4 gr2s1 vh-30 ba pa1-00 h-100 w-100' },
        ],
    },
    researchSection: {
        title: 'KDA Design Technologies Research',
        subtitle: 'Exclusive report on the impact of digital disruption across industries.',
        footer: 'KDA Design Technologies Research & Development',
        reports: [
            { title: 'Report 1', className: 'gc1s6 vh-30 ba pa1-00 w-100' },
            { title: 'Report 2', className: 'gc7s3 vh-30 ba pa1-00 w-100' },
            { title: 'Report 3', className: 'gc10s3 gr1s1 ba pa1-00 w-100' },
            { title: 'Report 4', className: 'gc1s3 ba pa1-00 w-100' },
            { title: 'Report 5', className: 'gc4s3 vh-30 ba pa1-00 w-100' },
            { title: 'Report 6', className: 'gc7s3 vh-30 ba pa1-00 w-100' },
            { title: 'Report 7', className: 'gc10s3 vh-30 ba pa1-00 w-100' },
        ],
    },
    thoughtLeadershipSection: {
        title: 'Thought Leadership',
        subtitle: 'Our leaders share insights on Live Enterprise.',
        ctaTo: 'thought-leadership',
        ctaLabel: 'Read More',
        items: [
            { title: 'Article 1', details: 'a link to the article' },
            { title: 'Article 2', details: 'a link to the article' },
            { title: 'Article 3', details: '' },
            { title: 'Article 4', details: '' },
        ],
    },
    responsiveGridStyle: {
        gridTemplateColumns: 'repeat(auto-fit, minmax(256px, 1fr))',
    },
    footerText: 'Info Footer',
}
